import Vue from 'vue'
import App from './forum.vue';
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import "../../styles/index.css";
import store from "../../store";
import "../../icons"

Vue.use(ElementUI);
//注册全局过滤器
import * as filters from "../../common/filter";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
// if(location.pathname == '/forum.html' && location.search == "?exhibition_id=29"){
//  location.href = "/internationalFair.html?exhibition_id=29#/"
// }
new Vue({
  render: h => h(App),
  store,
}).$mount('#app');
